const BUTTON_CIRCLE_ACTIONS_TO_FONTAWESOME_ICON = Object.freeze({
  close: ['far', 'xmark'],
  ellipsis: ['far', 'ellipsis'],
  expand: ['far', 'list'],
  pin: ['far', 'thumbtack'],
  add: ['far', 'circle-plus'],
});

export const BUTTON_LIGHT_ACTIONS_TO_FONTAWESOME_ICON = Object.freeze({
  create: 'plus',
});

export const BUTTON_LINK_ACTIONS_TO_FONTAWESOME_ICON = Object.freeze({
  other_page: 'forward',
});

export default BUTTON_CIRCLE_ACTIONS_TO_FONTAWESOME_ICON;
